
import Cookies from 'js-cookie'
import { timeZone } from './setting'

const RESULT = 'result'
const TOKEN = 'token'
const EXPIRES_ON = 'expires_on'
const SET_TIMEZONE = 'timaZome'

function getCookie(key) {
    return Cookies.get(key)
}

function setCookie(key, value) {
    Cookies.set(key, value)
}

function removeCookie(key) {
    Cookies.remove(key)
}

export function getToken() {
    return getCookie(TOKEN)
}

export function getExpire() {
    return getCookie(EXPIRES_ON)
}

export function getTimeZone() {
    let timezone = timeZone
    if (getCookie(SET_TIMEZONE)) {
        timezone = getCookie(SET_TIMEZONE)
    }
    return timezone
}

export function setToken(obj) {
    const { result, token, expires_on } = obj
    setCookie(RESULT, result)
    setCookie(TOKEN, token ? token : "")
    setCookie(EXPIRES_ON, expires_on ? expires_on : "")
}


export function clearToken() {
    removeCookie(RESULT)
    removeCookie(TOKEN)
    removeCookie(EXPIRES_ON)
}


// WEBPACK FOOTER //
// ./src/lib/auth.js